<template>
  <div class="sarai-management" :class="{ 'sarai-add-mode': isAddModalShow }">
    <ShowGuideTutorial v-if="!isAddModalShow" module="sarai-details" />

    <!-- list -->
    <div v-if="!isAddModalShow" class="p-6 pt-0">
      <vs-table id="sarai-list" class="vs-con-loading__container" stripe :sst="true" maxHeight="800px" search
        @search="updateSearchQuery" @change-page="handleChangePage" @sort="handleSort" :total="saraiFilteredCount"
        :max-items="length" :data="saraiList">
        <template slot="header">
          <div class="mb-2 flex items-center sarai-toolbar">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (saraiFilteredCount && 1)) || 0 }}
                      -
                      {{ saraiFilteredCount - page * length > 0 ? page * length : saraiFilteredCount }}
                      of {{ saraiTotal || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <vs-button v-if="isEditable" class="sarai-toolbar-btn" @click="viewBookings" color="dark">
              View Bookings
            </vs-button>
            <vs-button v-if="isEditable" class="sarai-toolbar-btn" @click="createBooking" color="dark">
              New Booking
            </vs-button>
            <vs-button v-if="isEditable" class="sarai-toolbar-btn" @click="toggleAddModal" color="dark">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Add Sarai
            </vs-button>
            <vs-button class="sarai-toolbar-btn" icon-pack="feather" icon="icon-refresh-ccw" color="dark"
              @click="refreshSaraiData">Refresh</vs-button>
            <vs-button v-if="isEditable && selectedRows.length" @click="bulkDeleteRecords" color="danger" size="default"
              style="padding: 12px 30px; margin-left: 10px">
              <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" /> Delete Selected
            </vs-button>

          </div>
        </template>

        <template slot="thead">
          <vs-th v-if="isEditable">
            <vs-checkbox :value="isAllSelected" :indeterminate="isSomeSelected" @change="toggleSelectAll" />
          </vs-th>
          <vs-th>Sr#</vs-th>
          <vs-th>Name</vs-th>
          <vs-th>Rooms</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Verified</vs-th>
          <vs-th>Draft</vs-th>
          <vs-th v-if="isEditable">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td class="flex justify-start" v-if="isEditable">
              <vs-checkbox :value="selectedRows.includes(tr._id)" @change="toggleRowSelection(tr._id)" />
            </vs-td>
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">
              <span class="cursor-pointer capitalize" @click.stop="editSarai(tr)">{{ tr.name || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <span>{{ calculateTotalRooms(tr) }}</span>
            </vs-td>
            <vs-td class="text-left">
              <vs-switch v-model="tr.is_active" @change="updateSaraiStatus(tr._id, tr.is_active)"
                :disabled="!isEditable || updatingSarai[`status_${tr._id}`]">
                <span slot="on">Active</span>
                <span slot="off">Inactive</span>
              </vs-switch>
            </vs-td>
            <vs-td class="text-left">
              <vs-switch v-model="tr.is_verified" @change="updateSaraiVerified(tr._id, tr.is_verified)"
                :disabled="!isEditable || updatingSarai[`verified_${tr._id}`]">
                <span slot="on">Verified</span>
                <span slot="off">Not Verified</span>
              </vs-switch>
            </vs-td>
            <vs-td class="text-left">
              <vx-tooltip :text="tr.is_draft ? 'Pending changes to publish' : 'No changes for publish'">
                <span class="cursor-pointer">{{ tr.is_draft ? 'Yes' : 'No' }}</span>
              </vx-tooltip>
            </vs-td>
            <vs-td v-if="isEditable">
              <div class="inline-flex">
                <vx-tooltip text="Manage Rooms">
                  <feather-icon @click.stop="manageRooms(tr._id)" icon="LayersIcon"
                    svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip text="View Dashboard">
                  <feather-icon @click.stop="viewDashboard(tr._id)" icon="BarChart2Icon"
                    svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip text="Edit Sarai">
                  <feather-icon @click.stop="editSarai(tr)" icon="EditIcon"
                    svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip text="Delete Sarai">
                  <feather-icon @click.stop="deleteSarai(tr)" icon="TrashIcon"
                    svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <!-- Custom Pagination -->
      <vs-pagination v-if="saraiFilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5"
        class="mt-8"></vs-pagination>
    </div>
    <sarai-action-page v-if="isAddModalShow" :gurudwara-id="gurudwaraId" :sarai-id="editingSaraiId"
      :is-edit-mode="isEditMode" @close="closeModal" />
  </div>
</template>

<script>
import axios from '@/axios'
import ShowGuideTutorial from '../show-guide-tutorial.vue'
import SaraiActionPage from './action'

export default {
  name: 'SaraiManagement',
  components: {
    ShowGuideTutorial,
    SaraiActionPage
  },
  props: {
    gurudwaraId: {
      type: String,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      saraiList: [],
      saraiTotal: 0,
      saraiFilteredCount: 0,
      loading: false,
      updatingSarai: {}, // Track which sarai is being updated to prevent duplicate calls
      deletingSarai: null, // Track which sarai is being deleted
      selectedRows: [],
      order: [],
      length: 100,
      page: 1,
      search: '',
      isAddModalShow: false,
      editingSaraiId: null,
      isEditMode: false
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.saraiFilteredCount / this.length)
    },
    /** Check if all checkboxes are selected */
    isAllSelected() {
      return this.selectedRows.length === this.saraiList.length && this.saraiList.length > 0
    },
    /** Check if some checkboxes are selected (for indeterminate state) */
    isSomeSelected() {
      return this.selectedRows.length > 0 && this.selectedRows.length < this.saraiList.length
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#sarai-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#sarai-list > .con-vs-loading')
      }
    },
    page() {
      this.loadSaraiList()
    }
  },
  mounted() {
    this.loadSaraiList()
  },
  methods: {
    async loadSaraiList() {
      this.loading = true
      try {
        const response = await axios.get('/admin/sarai', {
          params: {
            gurudwara: this.gurudwaraId,
            limit: this.length,
            page: this.page,
            search: this.search,
            ...(this.order.length > 0 && { order: this.order })
          }
        })
        if (response.data.success) {
          this.saraiList = response.data.data.results || []
          this.saraiTotal = response.data.data.totalResults || 0
          this.saraiFilteredCount = response.data.data.totalResults || response.data.data.total || 0
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to load sarai list',
          color: 'danger',
          position: 'top-center'
        })
      } finally {
        this.loading = false
      }
    },
    async refreshSaraiData() {
      try {

        // Reset to first page
        this.page = 1

        // Fetch fresh data
        await this.loadSaraiList()

        this.$vs.notify({
          title: 'Success',
          text: 'Data refreshed successfully',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check',
          position: 'top-center'
        })
      } catch (error) {
        console.error('Refresh error:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to refresh data',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center'
        })
      }
    },
    viewBookings() {
      this.$router.push(`/gurudwara/${this.gurudwaraId}/sarai/bookings`)
    },
    createBooking() {
      this.$router.push(`/gurudwara/${this.gurudwaraId}/sarai/bookings?newBooking=1`)
    },
    toggleAddModal() {
      this.isEditMode = false
      this.editingSaraiId = null
      this.isAddModalShow = true
    },
    closeModal() {
      this.isAddModalShow = false
      this.isEditMode = false
      this.editingSaraiId = null
      this.loadSaraiList()
    },
    viewDashboard(saraiId) {
      this.$router.push(`/gurudwara/${this.gurudwaraId}/sarai/${saraiId}/dashboard`)
    },
    manageRooms(saraiId) {
      this.$router.push(`/gurudwara/${this.gurudwaraId}/sarai/${saraiId}/rooms`)
    },
    editSarai(sarai) {
      this.isEditMode = true
      this.editingSaraiId = sarai._id
      this.isAddModalShow = true
    },
    /** Toggle Select All */
    toggleSelectAll() {
      if (this.selectedRows.length === this.saraiList.length) {
        this.selectedRows = []
      } else {
        this.selectedRows = this.saraiList.map((tr) => tr._id)
      }
    },
    /** Toggle Individual Row Selection */
    toggleRowSelection(id) {
      const index = this.selectedRows.indexOf(id)
      if (index === -1) {
        this.selectedRows.push(id)
      } else {
        this.selectedRows.splice(index, 1)
      }
    },
    /** Bulk Delete */
    bulkDeleteRecords() {
      if (this.selectedRows.length === 0) return

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Bulk Delete`,
        text: `Are you sure you want to delete ${this.selectedRows.length} records?`,
        accept: () => this.deleteMultipleRecords(),
        acceptText: 'Delete'
      })
    },
    /** Bulk Delete API Call */
    async deleteMultipleRecords() {
      try {
        const deletePromises = this.selectedRows.map((id) => axios.delete(`/admin/sarai/${id}`))
        await Promise.all(deletePromises)
        this.$vs.notify({
          title: 'Success',
          text: `${this.selectedRows.length} sarai deleted successfully`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.selectedRows = []
        this.loadSaraiList()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to delete sarai',
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    async deleteSarai(sarai) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Are you sure you want to delete this sarai "${sarai.name}"? This action cannot be undone.`,
        accept: async () => {
          this.deletingSarai = sarai._id
          try {
            await axios.delete(`/admin/sarai/${sarai._id}`)
            this.$vs.notify({
              title: 'Success',
              text: 'Sarai deleted successfully',
              color: 'success',
              position: 'top-center'
            })
            this.loadSaraiList()
          } catch (error) {
            this.$vs.notify({
              title: 'Error',
              text: (error.response && error.response.data && error.response.data.message) || 'Failed to delete sarai',
              color: 'danger',
              position: 'top-center'
            })
          } finally {
            this.deletingSarai = null
          }
        },
        acceptText: 'Delete'
      })
    },
    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.loadSaraiList()
    },
    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.loadSaraiList()
    },
    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.loadSaraiList()
    },
    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.loadSaraiList()
    },
    async updateSaraiStatus(saraiId, status) {
      if (this.updatingSarai[`status_${saraiId}`]) {
        return
      }

      this.updatingSarai[`status_${saraiId}`] = true

      const statusValue = Boolean(status)

      try {
        await axios.put(`/admin/sarai/${saraiId}`, { is_active: statusValue })
        this.$vs.notify({
          title: 'Success',
          text: 'Status updated successfully',
          color: 'success',
          position: 'top-center'
        })
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to update status',
          color: 'danger',
          position: 'top-center'
        })
        this.loadSaraiList()
      } finally {
        this.updatingSarai[`status_${saraiId}`] = false
      }
    },
    async updateSaraiVerified(saraiId, verified) {
      if (this.updatingSarai[`verified_${saraiId}`]) {
        return
      }

      this.updatingSarai[`verified_${saraiId}`] = true

      const verifiedValue = Boolean(verified)

      try {
        await axios.put(`/admin/sarai/${saraiId}`, { is_verified: verifiedValue })
        this.$vs.notify({
          title: 'Success',
          text: 'Verification status updated successfully',
          color: 'success',
          position: 'top-center'
        })
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to update verification status',
          color: 'danger',
          position: 'top-center'
        })
        this.loadSaraiList() // Reload to revert change
      } finally {
        this.updatingSarai[`verified_${saraiId}`] = false
      }
    },
    calculateTotalRooms(sarai) {
      if (!sarai || !sarai.rooms || !Array.isArray(sarai.rooms)) return 0
      return sarai.rooms.reduce((total, room) => total + (Number(room.number_of_rooms) || 1), 0)
    }
  }
}
</script>

<style scoped>
.sarai-management {
  min-height: 400px;
}

.sarai-toolbar {
  gap: 10px;
  flex-wrap: wrap;
}

.sarai-toolbar-btn {
  margin: 0 !important;
  min-height: 42px !important;
  height: 42px !important;
  padding: 0 16px !important;
  border: 1px solid #ffffff !important;
}

/* Keep Add/Edit Sarai form self-contained — avoid outer tab scroll clipping CTAs */
.sarai-management.sarai-add-mode {
  height: calc(100vh - 280px);
  min-height: 400px;
  overflow: hidden;
}

.sarai-management.sarai-add-mode >>> .sarai-form-container {
  max-height: 100%;
}
</style>
